import { createContext, useState, useContext } from 'react'

const OrderEventContext = createContext(null)

export const OrderEventProvider = ({ children }) => {
    const [currentOrderId, setCurrentOrderId] = useState(null)

    return <OrderEventContext.Provider value={{ currentOrderId, setCurrentOrderId }}>{children}</OrderEventContext.Provider>
}

export const useOrderEventContext = () => useContext(OrderEventContext)
